import { FC } from 'react'

import { colors } from '../../theme'
import Highlight from '../Highlight'
import ContentCards from '../ContentCards'
import { ContentCardProps } from '../ContentCard'
import { ContentCardGroupProps } from '../ContentCardGroup'
import { ECollapsable } from '../Collapsable/types'

import * as SC from './styled'

export type RecipeMenuSectionProps = {
  title?: string
  items: ((ContentCardProps | ContentCardGroupProps) & { id?: string })[]
}

const RecipeMenuSection: FC<RecipeMenuSectionProps> = ({ title, items }) => {
  return (
    <SC.ColabspableContainer
      header={
        title && (
          <SC.SectionTitle>
            <Highlight
              backgroundColor={colors.pink}
              color={colors.pureBlack}
              text={title}
            />
          </SC.SectionTitle>
        )
      }
      isCollapsable={ECollapsable.MOBILE}
      isOpenOnInit={true}
    >
      <SC.Inner>{items?.length > 0 && <ContentCards items={items} />}</SC.Inner>
    </SC.ColabspableContainer>
  )
}

export default RecipeMenuSection
